import { ToasterService } from '../components/Toaster/toaster.service';
import useService from './useService';

const useToaster = () => useService(ToasterService);

export default useToaster;
